const ContactInfo = () => {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-serif font-bold text-[#1B3A52] mb-3">Contact Information</h2>
        <p className="text-gray-600 text-sm mb-6">
          Reach out to us through any of the following channels. We're here to help and answer any questions you may have.
        </p>
      </div>

      {/* Contact Cards */}
      <div className="space-y-5">
        {/* Email */}
        <div className="bg-gray-50 rounded-lg p-5 hover:shadow-lg transition-shadow">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 bg-[#D4AF37] rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-mail-line text-white text-lg"></i>
            </div>
            <div>
              <h3 className="text-base font-semibold text-[#1B3A52] mb-2">Email</h3>
              <p className="text-gray-600 text-xs mb-2">Send us an email anytime</p>
              <a href="mailto:info@leavittpeakpress.com" className="text-[#D4AF37] hover:text-[#c49d2f] transition-colors text-sm font-medium cursor-pointer">
                info@leavittpeakpress.com
              </a>
            </div>
          </div>
        </div>

        {/* Phone */}
        <div className="bg-gray-50 rounded-lg p-5 hover:shadow-lg transition-shadow">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 bg-[#D4AF37] rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-phone-line text-white text-lg"></i>
            </div>
            <div>
              <h3 className="text-base font-semibold text-[#1B3A52] mb-2">Phone</h3>
              <p className="text-gray-600 text-xs mb-2">Call us toll-free for any inquiries</p>
              <a href="tel:+18885490988" className="text-[#D4AF37] hover:text-[#c49d2f] transition-colors text-sm font-medium cursor-pointer">
                1-888-549-0988
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Social Media */}
      <div className="bg-[#1B3A52] rounded-lg p-5">
        <h3 className="text-lg font-semibold text-white mb-3">Connect With Us</h3>
        <p className="text-white/80 text-xs mb-5">
          Follow Leavitt Peak Press on Facebook for daily inspiration and updates
        </p>
        <div className="flex items-center gap-4">
          <a href="https://www.facebook.com/leavittpeakpress" target="_blank" rel="noopener noreferrer" className="w-11 h-11 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#D4AF37] transition-all cursor-pointer">
            <i className="ri-facebook-fill text-white text-lg"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
